<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previosMaintain"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2>Maintenance & Repair</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />

        <div class="box" v-if="allContainerDetail.length>0">
          <div class="box-header">
            <h3 class="box-title">Container Details &nbsp;</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="MaingateInContainer" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Vehicle Number</th>
                  <th>Container Number</th>
                  <th>Container Size</th>
                  <th>Estimation Amount</th>
                  <th
                    v-if="maintain.status!='Approved' && maintain.status!='Sent_For_Approval'"
                  >Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in allContainerDetail" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.vehicleNo }}</td>
                  <td>{{item.containerNo }}</td>
                  <td>{{item.containerTypeId }}</td>
                  <td>{{(item.materialCost=='' || item.materialCost=='0' || item.materialCost==null)?"Survey Pending":item.materialCost }}</td>

                  <td v-if="maintain.status!='Approved' && maintain.status!='Sent_For_Approval'">
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="viewEditContainerPage(item.gateInId,item.containerGateInId)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <hr class="hr-s" />
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Gate-In No.</label>
              <b-form-input :formatter="capitalizeAll"
                id="gateInSeries"
                name="gateInSeries"
                v-model="maintain.gateInSeries"
                disabled
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!maintain.gateInSeries">{{gateInSeriesError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <md-layout md-flex="100">
              <label>Estimation Amount</label>
              <b-form-input :formatter="capitalizeAll"
                id="estimationAmount"
                name="estimationAmount"
                v-model="maintain.estimationAmount"
                disabled
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!maintain.estimationAmount">{{estimationAmountError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <md-layout md-flex="100" v-if="maintain.maintainenceId!=''">
              <label>Approval Amount</label>
              <b-form-input :formatter="capitalizeAll"
                id="approvalAmount"
                name="approvalAmount"
                v-model="maintain.approvalAmount"
                :disabled="maintain.status=='Approved'?true:false"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!maintain.approvalAmount ">{{approvalAmountError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-layout md-flex="100" v-if="maintain.maintainenceId!=''">
              <label for="status">Approval Status</label>
              <md-select
                name="status"
                id="status"
                v-model="maintain.status"
                :disabled="maintain.status=='Approved'?true:false"
              >
                <md-option value>Select Approval Status</md-option>
                <md-option value="Approved">Approved</md-option>
                <md-option value="Rejected">Rejected</md-option>
              </md-select>
            </md-layout>
            <span class="error" v-if="!maintain.status">{{statusError}}</span>
          </md-layout>
        </md-layout>

        <hr />
        <md-layout md-gutter v-if="maintain.maintainenceId!=''">
          <!-- <h4>Survey Date:</h4> -->
          <md-layout md-flex="5"></md-layout>
          <h4>Approved Date:</h4>
          <md-layout md-flex="15"></md-layout>
          <h4>Repair Date:</h4>
        </md-layout>
        <md-layout md-gutter v-if="maintain.maintainenceId!=''">
          <!-- <md-layout md-flex='20'>
<date-picker lang="en"  v-model="maintain.surveyDate" :disabled="permissionStatus" id="Date" ></date-picker>
<span class="error" v-if="!maintain.surveyDate" >{{surveyDateError}} </span>
          </md-layout>-->
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <date-picker
            :format="selectDateFormat"
              lang="en"
              v-model="maintain.approvedDate"
              :disabled="permissionStatus"
              id="Date"
            ></date-picker>
            <!-- <span class="error" v-if="!maintain.approvedDate" >{{approvedDateError}} </span> -->
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <date-picker
            :format="selectDateFormat"
              lang="en"
              v-model="maintain.repairDate"
              :disabled="permissionStatus"
              id="Date"
            ></date-picker>
            <!-- <span class="error" v-if="!maintain.repairDate" >{{repairDateError}} </span> -->
          </md-layout>
        </md-layout>

        <hr />
        <md-layout md-gutter class="mrgtop-button">
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="addRefuelStation"
              id="addButtonLoader"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="mailToShippingLine"
              v-if="maintain.estimationAmount!=null && maintain.maintainenceId!='' && maintain.status!='Approved' && maintain.status!='Sent_For_Approval'"
              id="addButtonLoader1"
            >Send For Approval</md-button>
            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22222"
      @close="onClose22222"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Yard")) {
      this.$store.dispatch("setCurrentRoute", "/yard/GateIn");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editPOId") != "" &&
          this.$sessionsStorage.get("editPOId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      maintain: {
        surveyDate: "",
        approvedDate: "",
        repairDate: "",
        gateInSeries: "",
        estimationAmount: "",
        approvalAmount: "",
        status: "",
        gateInId: "",
        itemMasterId: "",
        maintainenceId: ""
      },
      //surveyDateError:"",
      statusError: "",
      gateInSeriesError: "",
      // approvedDateError:"",
      // repairDateError:"",
      estimationAmountError: "",
      approvalAmountError: "",
      itemModal: {
        itemMaintainenceId: "",
        maintainenceId: "",
        itemId: "",
        itemNameCode: "",
        poOrderId: "",
        itemCode: "",
        itemName: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: ""
      },
      stockInDetails: {
        poOrderId: "",
        poItemId: "",
        maintenanceType: "",
        itemId: "",
        location: "",
        addedByPerson: "",
        department: "",
        poDate: "",
        uploadPoDoc: "",
        vendorName: "",
        specificPoDetail: ""
      },

      validate: true,

      maintenanceTypeError: "",
      locationError: "",
      addedByPersonError: "",
      departmentError: "",
      poDateError: "",
      vendorNamError: "",
      employeeMaster: [
        {
          employeeName: "ajit"
        }
      ],
      locationMaster: [
        {
          pickupLocation: "mumbai"
        }
      ],
      vendorMaster: [],
      departmentMaster: [],

      itemDetail: [
        {
          itemCode: "ajit"
        }
      ],
      locationDetail: [{}],
      dapartmentDetail: [],
      vendorDetail: [],
      itemArrayShow: [],
      itemNameError: "",
      ratePerUnitError: "",
      itemQuantityError: "",
      itemCodeError: "",
      allContainerDetail: [],

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editMaintainenceRepId") != "" &&
          this.$sessionsStorage.get("editMaintainenceRepId") != undefined
            ? "Update"
            : "Submit",
        FormVal:
          this.$sessionsStorage.get("editMaintainenceRepId") != "" &&
          this.$sessionsStorage.get("editMaintainenceRepId") != undefined
            ? "Update"
            : "New"
      }
    };
  },

  mounted() {},
  beforeDestroy() {
    // this.$sessionsStorage.set("editPOId", "");
  },
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {
    viewDocument() {
      return this.stockInDetails.uploadPoDoc.split(",");
    },

    itemMasterList() {
      return this.itemDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    }
  },
  methods: {
    viewEditContainerPage(gateID, ContainerID) {
      this.$sessionsStorage.set("editGateInId", gateID);
      this.$sessionsStorage.set("editContainerId", ContainerID);

      // let array = this.itemArrayShow.filter(x => {
      //   return x.poItemId == itemID;
      // });

      // Object.keys(array[0]).map(x => {
      //   this.itemModal[x] = array[0][x] || "";
      // });
      // this.itemModal.itemNameCode=this.itemModal.itemName + "-" + this.itemModal.itemCode

      this.$router.push({
        path: "/yard/editContainerRepair"
      });
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files;
      // console.log(files);

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/Api_Maintenance/uploadFileStockIn.php`, formData, config)
        .then(result => {
          this.stockInDetails.uploadPoDoc = result.data;
        })
        .catch(err => {
          throw err;
        });
    },
    finalAmount() {
      let amount =
        parseFloat(this.itemModal.ratePerUnit) *
        parseFloat(this.itemModal.itemQuantity);
      this.itemModal.totalAmount = amount;
    },
    JqueryFun() {
      return $(function() {
        $("#MaingateInContainer").DataTable();
        $("#MaintainenceTable").DataTable();
      });
    },
    validateModal() {
      let validate_new = true;

      if (this.itemModal.itemCode == "") {
        $("#itemCode").focus();
        this.itemCodeError = "Enter Item Code";
        validate_new = false;
      }
      if (this.itemModal.itemQuantity == "") {
        $("#itemQuantity").focus();
        this.itemQuantityError = "Enter Quantity ";
        validate_new = false;
      }
      if (this.itemModal.ratePerUnit == "") {
        $("#ratePerUnit").focus();
        this.ratePerUnitError = "Enter  Rate per unit";
        validate_new = false;
      }
      if (this.itemModal.itemName == "") {
        $("#itemName").focus();
        this.itemNameError = "Enter item name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    onClose22222(type) {
      this.$router.push({
        path: "/yard/viewMaintain"
      });
    },

    addStockFrom(Id) {
      this.$sessionsStorage.set("editPOId", Id);

      this.$router.push({
        path: "/stockIn"
      });
    },

    findItemCode(item) {
      // console.log(item)
      console.log(item);

      this.itemModal.itemName = item.itemName;
      this.itemModal.ratePerUnit = item.ratePerUnit;
      this.itemModal.itemId = item.itemId;
      this.itemModal.itemCode = item.itemCode;
    },
    getData() {
      let vehicle_drive = {
        itemCode: "itemCode",
        maintainenceId: this.$sessionsStorage.get("editMaintainenceRepId"),
        gateInId: this.$sessionsStorage.get("editGateInId")
      };
      //console.log("dadaa",this.$sessionsStorage.get("editGateInId"))

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/fetchToMaintainenceIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.maintain.estimationAmount = data.estimstionAmount;

            if (
              this.$sessionsStorage.get("editMaintainenceRepId") != undefined &&
              this.$sessionsStorage.get("editMaintainenceRepId") != ""
            ) {
              this.viewStockDetail();
            }
            this.viewEditServiceEstimation();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    viewEditServiceEstimation() {
      let edit_SE = {
        editClient: "editClient",
        gateInId: this.$sessionsStorage.get("editGateInId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewEditGateIn.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          console.log(data);

          if ( status == 200 && data) {
            data.editClient[0].containerGateInId += ",";
            this.maintain.gateInSeries = data.editClient[0].gateInSeries;
            this.maintain.gateInId = data.editClient[0].gateInId;

            this.showServiceEst(data.editClient[0].containerGateInId);
          }
        })
        .catch(error => {});
    },

    showServiceEst(serviceid) {
      let payload = {
        containerGateInId: serviceid,
        gateInId: ""
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewGateInContainer.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.allContainerDetail = data.itemArray;
            }
            console.log("por", data.itemArray);

            this.JqueryFun();
            // this.$refs["addPop1"].close();
          }
        })
        .catch(error => {});
    },
    mailToShippingLine() {
      let payload = {
        sendMail: "sendMail",
        gateInId: this.$sessionsStorage.get("editGateInId"),
        maintainenceId: this.$sessionsStorage.get("editMaintainenceRepId"),
        estimationAmount: this.maintain.estimationAmount
      };

      $("#addButtonLoader1").css("display", "none");
      $("#loader1").css("display", "block");
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/mailToShippingLine.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          console.log("===11111", result.data);
          $("#addButtonLoader1").css("display", "block");
          $("#loader1").css("display", "none");
          this.alert.content = "Mail Sent";
          this.$refs["addPop22222"].open();
        })

        .catch(error => {});
    },

    // addItem() {
    //   if (this.maintain.maintainenceId != "") {
    //     this.itemModal["maintainenceId"] = this.maintain.maintainenceId;
    //   } else {
    //     this.itemModal["maintainenceId"] = "";
    //   }
    //   //  console.log("");
    //   this.validateModal();
    //   if (this.validate != false) {
    //     // this.$refs["dialog2"].close();
    //     let options = {
    //       method: "POST",
    //       url: `${URL_BASE}/Api_Yard/addMaintanenceItem.php`,
    //       data: JSON.stringify(this.itemModal),
    //       crossDomain: true,
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "application/json",
    //         Authorization: this.$sessionsStorage.get("loginId")
    //       }
    //     };
    //     axios(options)
    //       .then(result => {
    //         const { statusText, status, data } = result;
    //         if ( status == 200 && data) {
    //           console.log("==", data);
    //           this.maintain.itemMasterId += data.Id + ",";
    //           console.log("==", data.Id);
    //           Object.keys(this.itemModal).map(x => {
    //             this.itemModal[x] = "";
    //           });
    //           this.itemNameError = "";
    //           this.itemCodeError = "";
    //           this.ratePerUnitError = "";
    //           this.itemQuantityError = "";

    //           // this.alert.content = "Added Succesfully";
    //           // this.$refs["addPop1"].open();
    //           this.onClose1();
    //         }
    //       })
    //       .catch(error => {});
    //   }
    // },
    onClose(type) {
      this.$router.push({
        path: "/yard/viewMaintain"
      });
    },
    onClose1() {
      this.itemArrayShow = [];

      let payload = {
        itemMaintainenceId: this.maintain.itemMasterId
      };
      if (this.maintain.maintainenceId != "") {
        payload["maintainenceId"] = this.maintain.maintainenceId;
      } else {
        payload["maintainenceId"] = "";
      }
      console.log("==", payload);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewMaintainenceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
            }

            this.JqueryFun();

            this.getData();
          }
        })
        .catch(error => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter(x => {
        return x.itemNameCode.toLowerCase().includes(query.toLowerCase());
      });
    },

    locationMasterFilter(list, query) {
      return this.locationMaster.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
      // console.log("gfdgdf");
    },

    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter(x => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
      // console.log("gfdgdf");
    },

    previosMaintain() {
      this.$router.push({
        path: "/yard/gateIn"
      });
    },
    openItemDialog() {
      this.$refs["dialog"].open();
    },
    viewStockDetail() {
      let payload = {
        editJob: "editJob",
        maintainenceId: this.$sessionsStorage.get("editMaintainenceRepId")
      };
      // console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewMaintanenceDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            // if (data.maintainenceId != "") {
            //   this.$sessionsStorage.set("editMaintainenceRepId", data.maintainenceId);
            // }
            // console.log(data);
            Object.keys(data.editJob[0]).map(x => {
              this.maintain[x] = data.editJob[0][x] || "";
            });
            this.JqueryFun();

            this.maintain.itemMasterId += ",";

            this.poItemView(this.maintain.itemMasterId);

            //console.log(data);
          }
        })
        .catch(error => {});
    },
    poItemView(poItemId) {
      this.itemArrayShow = [];

      let payload = {
        itemMaintainenceId: this.maintain.itemMasterId
      };

      payload["maintainenceId"] = "";

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/viewMaintainenceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
            }

            this.getData();
          }
        })
        .catch(error => {});
    },

    validateJobOrder() {
      let validate_new = true;

      if (this.maintain.gateInSeries == "") {
        $("#gateInSeries").focus();
        this.gateInSeriesError = "Enter Gate-In No.";
        validate_new = false;
      }
      if (this.maintain.estimationAmount == "") {
        $("#estimationAmount").focus();
        this.estimationAmountError = "Enter Estimation Amount";
        validate_new = false;
      }
      if (
        this.maintain.approvalAmount == "" &&
        this.maintain.maintainenceId != ""
      ) {
        $("#approvalAmount").focus();
        this.approvalAmountError = "Enter Approval Amount";
        validate_new = false;
      }
      if (this.maintain.status == "" && this.maintain.maintainenceId != "") {
        $("#status").focus();
        this.statusError = "Select Approved Status";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addRefuelStation() {
      this.validateJobOrder();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/addMaintainence.php`,
          data: JSON.stringify(this.maintain),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            console.log("===", result.data);
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
          })

          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
.marg-top {
  margin-top: 0%;
}
</style>


// WEBPACK FOOTER //
// maintainRepair.vue?33464613